import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { FileText, Home, Settings, Package, Receipt, TrendingUp } from 'lucide-react';
import AppHeader from '../components/AppHeader';

const enconOrange = '#ee7203';

const M45Hub = ({ user }) => {
  const navigate = useNavigate();
  
  // M4.5 Apps - will expand in the future
  const apps = [
    {
      id: 'proforma',
      title: 'Proforma',
      description: 'Create and manage professional proforma invoices',
      icon: FileText,
      route: '/proforma',
      color: enconOrange
    },
    {
      id: 'stock-transfer',
      title: 'Stock Transfer',
      description: 'Request stock transfers between branches',
      icon: Package,
      route: '/stock-transfer',
      color: enconOrange
    },
    {
      id: 'po-expenses',
      title: 'P.O. Expenses',
      description: 'Create and manage purchase order expenses',
      icon: Receipt,
      route: '/po-expenses',
      color: enconOrange
    },
    {
      id: 'price-increases',
      title: 'Price Increases',
      description: 'View upcoming supplier price increases',
      icon: TrendingUp,
      route: '/price-increases',
      color: enconOrange
    }
  ];

  // Mobile menu buttons
  const mobileMenuButtons = [
    {
      icon: Settings,
      label: 'Settings',
      onClick: () => navigate('/settings'),
      color: enconOrange
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Global Header */}
      <AppHeader 
        user={user}
        mobileMenuButtons={mobileMenuButtons}
        subHeaderLeft={
          <div className="flex items-center gap-1.5 rounded-full px-3 py-1 flex-shrink-0" style={{ background: 'rgba(0,0,0,0.22)' }}>
            <span className="text-white font-bold text-xs sm:text-sm whitespace-nowrap">M4.5 — Sales & Admin Tools</span>
          </div>
        }
      />

      {/* Main Content */}
      <div className="pt-[20px] px-4 md:px-6 pb-6 bg-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto">
          {/* Page Title */}
          <div className="mb-6">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">M4.5</h1>
            <p className="text-sm md:text-base text-gray-600">Sales and Admin Tools</p>
          </div>
          
          <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-6">Available Apps</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {apps.map((app) => {
              const IconComponent = app.icon;
              return (
                <Card
                  key={app.id}
                  className="transition-all duration-200 border-2 bg-white hover:shadow-xl cursor-pointer hover:-translate-y-1"
                  style={{ borderColor: app.color }}
                  onClick={() => navigate(app.route)}
                >
                  <CardHeader>
                    <div 
                      className="w-12 h-12 md:w-16 md:h-16 rounded-lg flex items-center justify-center mb-3 md:mb-4"
                      style={{ backgroundColor: app.color }}
                    >
                      <IconComponent className="h-6 w-6 md:h-8 md:w-8 text-white" />
                    </div>
                    <CardTitle className="text-xl md:text-2xl" style={{ color: '#1d1d1b' }}>
                      {app.title}
                    </CardTitle>
                    <CardDescription className="text-sm md:text-base" style={{ color: '#9d9d9c' }}>
                      {app.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <Button 
                      className="w-full font-medium"
                      style={{ backgroundColor: app.color, color: 'white' }}
                    >
                      Open App →
                    </Button>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default M45Hub;
